import { useEffect, useMemo, useState } from 'react';
import { match, select } from 'ts-pattern';

import chatttSDK from 'services/chattt';
import { useAuthorization } from 'components/Authorization';

import { Todo } from './components/ToDo';
import { useOpenChatFromOrder } from './useOpenChatFromOrder';

interface ModuleActionSchema {
  moduleName: 'todo' | 'chatFromOrder';
  action: 'open';
  jsonData: any;
}

export const useActionSchema = () => {
  const { token } = useAuthorization();
  const [action, setAction] = useState<ModuleActionSchema>(null!);

  const openChatFromOrder = useOpenChatFromOrder();

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      const { event: eventName, payload } = event.data;
      if (eventName === 'app:link') {
        const { moduleName, action, jsonParams } = payload;
        let jsonData;
        try {
          jsonData = JSON.parse(atob(decodeURIComponent(jsonParams)));
          console.log('jsonData', jsonData);
        } catch (err) {
          console.log('[jsonParams] parse error');
        }

        setAction({
          moduleName,
          action,
          jsonData,
        });
      }
    };

    window.addEventListener('message', handler, false);
    return () => {
      window.removeEventListener('message', handler, false);
    };
  }, []);

  useEffect(() => {
    if (chatttSDK?.account?.loginUser && token) {
      chatttSDK.account.loginUser(token);
    }

    return () => {
      if (chatttSDK?.account?.logoutUser && token) {
        chatttSDK.account.logoutUser(token);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const node = useMemo(() => {
    return match(action)
      .with(
        {
          moduleName: 'todo',
          action: 'open',
          jsonData: { id: select('id') },
        },
        (i: any) => {
          return <Todo key={Date.now()} id={i.id} />;
        },
      )
      .with(
        {
          moduleName: 'chatFromOrder',
          action: 'open',
          jsonData: {
            orderId: select('orderId'),
            storeId: select('storeId'),
            region: select('region'),
            tunnelType: select('tunnelType'),
          },
        },
        (jsonData: any) => {
          openChatFromOrder(jsonData);
          return null;
        },
      )
      .otherwise(() => null);
  }, [action, openChatFromOrder]);
  return node;
};

export const ActionSchema = () => {
  const actionSchema = useActionSchema();

  return actionSchema || <></>;
};
